import React from 'react';
import { Link } from 'react-router-dom';
import professorStephen from '../assets/images/professor-stephen.jpg';
import '../styles/About.css';
const About = () => {
  return (
    <section className="section about-section">
      <div className="container">
        <div className="about-content">
          <div className="about-image">
            <img src={professorStephen} alt="Professor Stephen Njenga" className="professor-img" />
          </div>
          <div className="about-text">
            <h2 className="section-title">About Professor Stephen Njenga</h2>
            <p>
              Professor Stephen Njenga is a commissioned Notary Public serving the Federal Way area
              and surrounding communities. With years of experience in document notarization, he
              provides professional, reliable, and efficient notary services.
            </p>
            <p>
              As a respected professional in the community, Professor Njenga understands the
              importance of accuracy and attention to detail when notarizing documents. He is
              committed to providing excellent customer service and ensuring your notarization needs
              are met with the utmost professionalism.
            </p>
            <p>
              Our office at 1305 S 312th St suite 202, Federal Way, WA 98003 is conveniently located
              and easily accessible. We also offer mobile notary services for your convenience.
            </p>
            <Link to="/about" className="btn btn-primary">
              Learn More
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

// At the end of the file:
export default About;